import React from "react";
import "../style/meettheteam.css";
import meetImage1 from "../assets/meetImage1.png";
import team from "../assets/team.png";
import medal from "../assets/medal.png";
import inLoveSmall from "../assets/inLoveSmall.png";
import markSmall from "../assets/markSmall.png";
import TeamMember from "./TeamMember";
import { NavLink } from "react-router-dom";

const MeetTheTeam = () => {
  return (
    <div>
      <section className="meet-section1">
        <img src={meetImage1} alt="meet" loading="lazy" />
      </section>
      <section className="meet-section2">
        <h1>Meet Our Dedicated Team</h1>
        <span>
          Our experienced, compassionate team of professionals is committed to
          providing
          <br /> exceptional care and support for every individual.
        </span>
      </section>
      <section className="meet-section3">
        {/* item 1 */}
        <div className="meet-section3-div">
          <img src={team} alt="meet" loading="lazy" />
          <h5>10+</h5>
          <span>Care Staff Members</span>
        </div>
        {/* item 2 */}
        <div className="meet-section3-div">
          <img src={medal} alt="meet" loading="lazy" />
          <h5>95%</h5>
          <span>Qualified Professionals</span>
        </div>
        {/* item 3 */}
        <div className="meet-section3-div meet-section3-div-span ">
          <img src={inLoveSmall} alt="meet" loading="lazy" />

          <span>
            Person Centered
            <br /> required ratio
          </span>
        </div>
        {/* item 4 */}
        <div className="meet-section3-div meet-section3-div-span">
          <img src={markSmall} alt="meet" loading="lazy" />

          <span>
            Continuous
            <br /> Professional
            <br /> Development for all
            <br /> employees
          </span>
        </div>
      </section>
      <section className="meet-section4">
        <h1>Leadership Team</h1>
        <p>
          Meet the experienced professionals who lead our care team and ensure
          the highest
          <br /> standards of service delivery.
        </p>
        <TeamMember />
      </section>
      <section className="meet-section5">
        <h1>Our Care Team</h1>
        <h5>
          Our dedicated care professionals bring specialized skills and genuine
          compassion to
          <br /> support residents in all aspects of daily life.
        </h5>
        <div className="meet-section5-div1">
          {/* item 1 */}
          <div className="meet-section5-div1-items">
            <img src={team} alt="people" loading="lazy" />
            <span>Team Lead</span>
          </div>
          {/* item 2 */}
          <div className="meet-section5-div1-items">
            <img src={team} alt="people" loading="lazy" />
            <span>Team Lead</span>
          </div>
          {/* item 3 */}
          <div className="meet-section5-div1-items">
            <img src={team} alt="people" loading="lazy" />
            <span>Support Staff</span>
          </div>
        </div>
        <div className="meet-section5-div1">
          {/* item 1 */}
          <div className="meet-section5-div1-items">
            <img src={team} alt="people" loading="lazy" />
            <span>Support Staff</span>
          </div>
          {/* item 2 */}
          <div className="meet-section5-div1-items">
            <img src={team} alt="people" loading="lazy" />
            <span>Support Staff</span>
          </div>
          {/* item 3 */}
          <div className="meet-section5-div1-items">
            <img src={team} alt="people" loading="lazy" />
            <span>Support Staff</span>
          </div>
        </div>
      </section>
      <section className="meet-section6">
        <h1>Our Team's Expertise</h1>
        <div className="meet-section6-div1">
          <div className="meet-section6-div1-items">
            <img src={medal} alt="medal" loading="lazy" />
            <h5>Professional Qualifications</h5>
            <ul>
              <li>• NVQ Levels 2-5 in Health & Social Care</li>
              <li>• Specialist mental health training</li>
              <li>• Learning disability support certifications</li>
            </ul>
          </div>
          <div className="meet-section6-div1-items">
            <img src={team} alt="people" loading="lazy" />
            <h5>Ongoing Development</h5>
            <ul>
              <li>• Monthly training workshops</li>
              <li>• Safeguarding and protection updates</li>
              <li>• Person-centered care methodology</li>
              <li>• First aid and emergency response</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="meet-section7">
        <div className="meet-section7-div1">
          <h1>Want to Meet Our Team?</h1>
          <h3>
            We'd love to introduce you to our dedicated professionals and show
            you
            <br /> how our team approach makes a difference in care quality.
          </h3>

          <div className="meet-section7-div1-navs">
            <NavLink to="/tour">Schedule a Visit</NavLink>
            <NavLink to="/">Read Success Stories</NavLink>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MeetTheTeam;
